import React, { useEffect, useState } from "react";
import { validatePositiveAmount } from "../../utils/amount";
import {
  FormControl,
  Select,
  MenuItem,
  Collapse,
  TextField,
  Autocomplete,
  Checkbox,
  Avatar,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  Typography,
  IconButton,
  Paper,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
} from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { Offcanvas } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { width } from "@mui/system";
import { OffcanvasBody } from "react-bootstrap";

import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  fetchAllEntities,
  getAllData,
  getAllNameList,
  postResource,
} from "../../apis/apiService";
import { toast } from "react-toastify";

// import * as React from 'react';
import clsx from "clsx";
import { styled, css } from "@mui/system";
import { Modal as BaseModal } from "@mui/material";
// import WeekPicker from "./WeeckPicker";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {
  LocalizationProvider,
  MonthCalendar,
  StaticDatePicker,
} from "@mui/x-date-pickers";
import MonthPicker from "../../components/budget/MonthPicker";
import dayjs from "dayjs";
// import { WeekPicker } from "./WeeckPicker";
import { Controller, useForm } from "react-hook-form";
import { RangePicker } from "../../components/budget/RangePicker";
import { useSelector } from "react-redux";
import {
  useFetchBudgetExpenseTableQuery,
  useFetchBudgetPaymentsQuery,
  useFetchBudgetSummaryTableQuery,
} from "../../slice/logdetailSlice";
// import Loader from "../../common/Loader";
import { DateRangePicker } from "react-date-range";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { WeekPicker } from "../../components/budget/WeeckPicker";
import Loader from "../../components/common/Loader";
// import { Button } from '@mui/base/Button';

export function NestedModal({ onApply, onCancel }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleApply = (date) => {
    onApply(date);
    handleClose(); // Close the modal
  };

  return (
    <div>
      <div className="w-100 border-0 ">
        <DateRangeIcon onClick={handleOpen} />
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
          {/* <Weekpic /> */}
          <WeekPicker onApply={handleApply} onCancel={onCancel} />
          {/* <RangePicker /> */}
          {/* <MonthPicker /> */}
        </ModalContent>
      </Modal>
    </div>
  );
}
export function NestedRange({ onApply, onCancel }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleApply = (dates) => {
    onApply(dates); // Pass the selected dates to the parent handler
    handleClose(); // Close the modal
  };

  return (
    <div>
      <DateRangeIcon onClick={handleOpen} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
          {/* <Weekpic /> */}
          {/* <WeekPicker  /> */}
          <RangePicker onApply={handleApply} onCancel={onCancel} />
          {/* <MonthPicker /> */}
        </ModalContent>
      </Modal>
    </div>
  );
}

export function NesteMonthdModal({ onApply, onCancel }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = (dates) => {
    onApply(dates); // Pass the selected dates to the parent handler
    handleClose(); // Close the modal
  };

  const handleCancel = () => {
    onCancel();
    handleClose(); // Close the modal
  };

  return (
    <div>
      {/* <Typography className="w-100 border-0 px-3 py-2 " onClick={handleOpen}>
        This Month
      </Typography> */}
      <DateRangeIcon onClick={handleOpen} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
          <MonthPicker onApply={handleApply} onCancel={handleCancel} />
        </ModalContent>
      </Modal>
    </div>
  );
}

const Backdrop = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={`${open ? "base-Backdrop-open" : ""} ${className}`}
      ref={ref}
      {...other}
    />
  );
});

const blue = {
  200: "#99CCFF",
  300: "#66B2FF",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  700: "#0066CC",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
};

const ModalContent = styled("div")(
  ({ theme }) => css`
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: 500;
    text-align: start;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0 4px 12px
      ${theme.palette.mode === "dark" ? "rgb(0 0 0 / 0.5)" : "rgb(0 0 0 / 0.2)"};
    padding: 24px;
    color: ${theme.palette.mode === "dark" ? grey[50] : grey[900]};

    & .modal-title {
      margin: 0;
      line-height: 1.5rem;
      margin-bottom: 8px;
    }

    & .modal-description {
      margin: 0;
      line-height: 1.5rem;
      font-weight: 400;
      color: ${theme.palette.mode === "dark" ? grey[400] : grey[800]};
      margin-bottom: 4px;
    }
  `
);

const projectSpan = [
  {
    label: "Project span",
    value: 0,
  },
  {
    label: "Project 2",
    value: 1,
  },
];

const AddPaymentComponent = ({ onapply, oncancel }) => {
  const project_id = localStorage.getItem("project_id");
  const [loading, isLoading] = useState(false);
  const { data, refetch } = useFetchBudgetPaymentsQuery(project_id);
  const {
    data: summaryData,
    refetch: summaryRefetch,
    currentData,
    isLoading: summary_isloading,
  } = useFetchBudgetSummaryTableQuery(project_id);
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
      remarks: "",
    },
  });
  const onSubmit = async (data) => {
    isLoading(true);
    const amount = parseInt(data.amount, 10);
    //console.log()("addd expense data :", data);
    const requestedData = {
      remarks: data.remarks,
      amount: amount,
    };
    try {
      const response = await postResource(
        "projects/budget",
        "addPayment",
        project_id,
        requestedData
      );
      if (response) {
        toast.success("Payment added successfully");
        // onapply();
        // reset();
        refetch();
        summaryRefetch();
        oncancel();
      }
      //console.log()("add expenses :", response);
    } catch (err) {
      const errorMsg = err.message;
      toast.error(errorMsg);
    } finally {
      isLoading(false);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="d-flex gap-1  align-items-center  mt-1 "
          onClick={oncancel}
        >
          <div className="">
            <IoIosArrowBack /* fontSize: "25px"*/ />
          </div>
          <Typography
            sx={{ textTransform: "capitalize" /* fontSize: "25px"*/ }}
          >
            add payment
          </Typography>
        </div>

        <div className=" p-4  paddingBtn">
          <div className=" my-4">
            <Typography
              sx={{
                textTransform: "capitalize",
                color: "#969696",
                fontSize: "20px",
                fontWeight: 400,
              }}
            >
              remarks
            </Typography>

            <TextField
              sx={{ width: "100%" }}
              name="remarks"
              {...register("remarks", {
                required: "Remarks field is required",
              })}
            ></TextField>
            {errors.remarks && (
              <p className="errorMsg">{errors.remarks.message}</p>
            )}
          </div>

          <div className=" paddingBtn">
            <Typography
              sx={{
                textTransform: "capitalize",
                color: "#969696",
                fontSize: "20px",
                fontWeight: 400,
              }}
            >
              amount
            </Typography>

            <TextField
              sx={{ width: "100%" }}
              name="amount"
              type="number"
              {...register("amount", { required: "Amount field is requied", validate: validatePositiveAmount })}
            ></TextField>
            {errors.amount && (
              <p className="errorMsg">{errors.amount.message}</p>
            )}
          </div>
        </div>
        <div className="d-flex p-3 align-items-center position-absolute bottom-0 w-100 bg-white gap-3 ">
          <button
            type="submit"
            className="add_btn"
            disabled={loading}
            onClick={onapply}
          >
            {loading ? "Adding..." : "Add"}
          </button>
          <button className="cancel_btn" type="button" onClick={oncancel}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};

const AddExpenseComponent = ({ oncancel, onapply, onclose }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
      remarks: "",
    },
  });
  const [loading, setLoading] = useState(false);
  const project_id = localStorage.getItem("project_id"); // pass value as 4 backend
  const { data, isLoading, refetch } =
    useFetchBudgetExpenseTableQuery(project_id);
  const onSubmit = async (data) => {
    setLoading(true);
    const amount = parseInt(data.amount, 10);
    const requestedData = {
      remarks: data.remarks,
      amount: amount,
    };
    try {
      const response = await postResource(
        "projects/budget",
        "addExpense",
        project_id,
        requestedData
      );
      if (response) {
        toast.success(response.message);
        refetch();
        oncancel();
      }
    } catch (err) {
      //console.log()("error in add expense budget : ", err);

      const errorMsg = err.message;
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <form action="" onSubmit={handleSubmit(onSubmit)}>
        <div
          className="d-flex gap-1  align-items-center  mt-1 "
          onClick={oncancel}
        >
          <div className="">
            <IoIosArrowBack /* fontSize: "25px"*/ />
          </div>
          <Typography
            sx={{ textTransform: "capitalize" /* fontSize: "25px"*/ }}
          >
            Add Expense
          </Typography>
        </div>

        <div className=" p-4  paddingBtn">
          <div className=" my-4">
            <Typography
              sx={{
                textTransform: "capitalize",
                color: "#969696",
                fontSize: "20px",
                fontWeight: 400,
              }}
            >
              remarks
            </Typography>

            <TextField
              sx={{ width: "100%" }}
              name="remarks"
              {...register("remarks", {
                required: "Remarks field is required",
              })}
            ></TextField>
            {errors.remarks && (
              <p className="errorMsg">{errors.remarks.message}</p>
            )}
          </div>

          <div className=" paddingBtn">
            <Typography
              sx={{
                textTransform: "capitalize",
                color: "#969696",
                fontSize: "20px",
                fontWeight: 400,
              }}
            >
              amount
            </Typography>

            <TextField
              sx={{ width: "100%" }}
              name="amount"
              type="number"
              {...register("amount", { required: "Amount field is requied", validate: validatePositiveAmount })}
            ></TextField>
            {errors.amount && (
              <p className="errorMsg">{errors.amount.message}</p>
            )}
          </div>
        </div>
        <div className="d-flex p-3 align-items-center position-absolute bottom-0 w-100 bg-white gap-3 ">
          <button
            type="submit"
            className="add_btn"
            disabled={loading}
            onClick={onapply}
          >
            {loading ? "Adding..." : "Add"}
          </button>
          <button className="cancel_btn" type="button" onClick={oncancel}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};
// //console.log()("API Response:", data);
export const BudgetTable = ({ filteredData }) => {
  //console.log()("API Response (filteredData):", filteredData);

  // Check if data exists
  const groupedData = filteredData?.data?.grouped_data || {};
  const hasData = Object.keys(groupedData).length > 0;

  // Show "No Data Found" if there's no data
  if (!hasData) {
    return (
      <Typography
        variant="h6"
        align="center"
        sx={{ margin: "20px", color: "gray" }}
      >
        No Data Found
      </Typography>
    );
  }

  // Transform API data for rendering
  const data = [];
  for (const [id, group] of Object.entries(groupedData)) {
    const { name, rates } = group;
    const overallTotalAmount = group?.rates?.total_amount || 0;
    const overallTotalHours = group?.rates?.total_hours || 0;

    const rows =
      rates?.details?.length > 0
        ? rates.details.map((detail) => ({
            hours: detail.hours || 0,
            rate: detail.rate || "No Data",
            startDate: detail.start_date || "No Data",
            endDate: detail.end_date || "No Data",
            totalHrs: detail.hours || "No Data",
            totalAmount: detail.hours * detail.rate || 0,
          }))
        : [
            {
              hours: 0,
              rate: "No Data",
              startDate: "No Data",
              endDate: "No Data",
              totalHrs: "No Data",
              totalAmount: 0,
            },
          ];

    data.push({
      id,
      name: name || "No Data",
      rows,
      totalHours: overallTotalHours,
      totalAmount: overallTotalAmount,
    });
  }

  //console.log()("Transformed Data for Table Rendering:", data);

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
      <Table stickyHeader sx={{ boxShadow: "none", border: "none" }}>
        <TableHead>
          <TableRow
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 2,
              backgroundColor: "#fff",
            }}
          >
            <TableCell>S.No</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Hours</TableCell>
            <TableCell>Rate / hr</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            <TableCell>Total Hrs</TableCell>
            <TableCell>Total Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((group, groupIndex) => (
            <React.Fragment key={group.id}>
              {group.rows.map((row, rowIndex) => (
                <TableRow key={`${group.id}-${rowIndex}`}>
                  {rowIndex === 0 && (
                    <>
                      <TableCell rowSpan={group.rows.length}>
                        {groupIndex + 1}
                      </TableCell>
                      <TableCell rowSpan={group.rows.length}>
                        {group.name}
                      </TableCell>
                    </>
                  )}
                  <TableCell>{row.hours}</TableCell>
                  <TableCell>{row.rate}</TableCell>
                  <TableCell>{row.startDate}</TableCell>
                  <TableCell>{row.endDate}</TableCell>
                  <TableCell>{row.totalHrs}</TableCell>
                  <TableCell>{row.totalAmount}</TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
          {/* Overall Total Row */}
          <TableRow
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 2,
              backgroundColor: "#fff",
            }}
          >
            <TableCell colSpan={7} align="right">
              <Typography fontWeight="bold">Overall Total Amount</Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight="bold">
                {filteredData?.data?.overall_total_amount?.toFixed(2) || 0}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const FixedExpenses = () => {
  const project_id = localStorage.getItem("project_id");
  const [expenses, setExpenses] = useState([]);
  const [totalAmount, setTotalAmount] = useState([]);
  const { data, isLoading } = useFetchBudgetExpenseTableQuery(project_id);
  const viewAllExpense = async () => {
    try {
      if (data && data.expenses) {
        setExpenses(data.expenses);
        setTotalAmount(data.total_amount);
      } else {
        setExpenses([]);
        setTotalAmount(0);
      }
    } catch (err) {
      const errorMsg = err.message;
      toast.error(errorMsg);
    }
  };
  useEffect(() => {
    viewAllExpense();
  }, [data]);

  return (
    <>
      <TableContainer component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="left" colSpan={2}>
                Remarks
              </TableCell>
              <TableCell align="center">Amount</TableCell>
              <TableCell align="center">Total Amount</TableCell>
            </TableRow>
          </TableHead>
          {isLoading ? (
            <Loader />
          ) : (
            <TableBody>
              {expenses.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography variant="subtitle1" color="textSecondary">
                      No Data Found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                expenses.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{`0${data.fixed_expense_id}`}</TableCell>
                    <TableCell align="left" colSpan={2}>
                      {data.comments}
                    </TableCell>
                    <TableCell align="center">
                      {data.amount.toLocaleString()}
                    </TableCell>
                    <TableCell align="center">
                      {data.amount.toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))
              )}

              {/* Sticky Total Row */}
              {expenses.length > 0 && (
                <TableRow
                  sx={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#fff",
                    zIndex: 1,
                  }}
                >
                  <TableCell colSpan={4} align="right">
                    <Typography marginRight={4} fontWeight="bold">
                      Total Amount
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography fontWeight="bold">
                      {totalAmount.toLocaleString(0)}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </>
  );
};

export const SummaryTable = () => {
  const [expanded, setExpanded] = useState(false);
  const [summaryList, setSummaryList] = useState([]);
  const project_id = localStorage.getItem("project_id");
  const { data, refetch, currentData, isLoading } =
    useFetchBudgetSummaryTableQuery(project_id);
  //console.log()("formated_data_payment_list query response :", data);
  // //console.log()("formated_data query response  currentData:", currentData);
  const viewAllPayments = async () => {
    try {
      setSummaryList(data);
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setSummaryList([]);
    }
  };

  useEffect(() => {
    viewAllPayments();
  }, [data]);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      sx={{
        overflowX: "auto",
        borderRadius: "4px",
        marginTop: 2,
        marginRight: "150px",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{ boxShadow: "none", transitionDelay: 200, transition: "2s ease" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={4}
                sx={{ backgroundColor: "#f5f5f5", textAlign: "center" }}
              >
                <Typography align="right" fontWeight="bold"></Typography>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  textAlign: "center",
                }}
              >
                <Typography
                  align="center"
                  textTransform="capitalize"
                  fontWeight="bold"
                >
                  Total Hrs
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  textAlign: "right",
                }}
              >
                <Typography
                  textTransform="capitalize"
                  fontWeight="bold"
                  align="right"
                >
                  Amount
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(summaryList) &&
              summaryList.map((row, index) => (
                <React.Fragment key={index}>
                  
                  <TableRow>
                    <TableCell colSpan={4} align="right">
                      {row.label === "Payments Received" && (
                        <IconButton onClick={toggleExpand} size="small">
                          <ExpandMoreIcon
                            sx={{
                              transform: expanded
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "0.3s",
                            }}
                          />
                        </IconButton>
                      )}
                      {row.label}
                    </TableCell>
                    <TableCell align="center">{row.total_hours}</TableCell>
                    <TableCell
                      align="right"
                      sx={{ color: row.color || "inherit" }}
                    >
                      {typeof row.totalAmount === "number"
                        ? row.totalAmount.toLocaleString()
                        : row.totalAmount}
                    </TableCell>
                  </TableRow>
                  {row.payments_received && (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{
                          paddingBottom: 0,
                          paddingTop: 0,
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                          <Box sx={{ margin: 1 }}>
                            <Table>
                              <TableBody>
                                {row.payments_received.map(
                                  (payment, paymentIndex) => (
                                    <TableRow key={paymentIndex}>
                                      <TableCell
                                        colSpan={5}
                                        align="center"
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "normal",
                                          px: "250px",
                                        }}
                                      >
                                        {`${payment.name} - ${payment.added_at}`}
                                      </TableCell>

                                      <TableCell
                                        align="right"
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "normal",
                                          marginRight: "200px",
                                        }}
                                      >
                                        {payment.amount.toLocaleString()}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export const PaymentsReceived = () => {
  const [payment, setPayment] = useState([]);
  const project_id = localStorage.getItem("project_id");
  const { data, refetch, isLoading } = useFetchBudgetPaymentsQuery(project_id);
  //console.log()("budget_response_in_RTKquery :", data);
  // setPayment(data);
  useEffect(() => {
    const viewAllPayments = async () => {
      if (data) {
        setPayment(data.payments);
      }
    };
    viewAllPayments();
  }, [data]);
  return (
    <Box
      sx={{
        overflowX: "auto",
        border: "1px solid #ccc",
        marginRight: "150px",
        marginBottom: 2,
      }}
    >
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2} style={{ backgroundColor: "#f5f5f5" }}>
                <Typography
                  fontWeight="bold"
                  align="right"
                  textTransform="capitalize"
                >
                  amount
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              payment.map((payment, index) => {
                const [date, time] = payment.added_at.split(" ");
                return (
                  <TableRow key={index}>
                    <TableCell>
                      {payment.comments} ({date} {time})
                    </TableCell>
                    <TableCell align="right">
                      {payment.amount.toLocaleString()}
                    </TableCell>
                  </TableRow>
                );
              })
              // const [date, time] = payment.added_at.split(" ");
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
const Budget = () => {
  const {
    handleSubmit,
    control,
    register,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      project_span: "all",
      // from_date: dayjs().format("YYYY-MM-DD"),
      // to_date: dayjs().format("YYYY-MM-DD"),
    },
  });
  const [budgetOpen, setBudgetOpen] = useState(true);
  const [openSummaryTable, setOpenSummaryTable] = useState(false);
  const [openPaymentReceivedTable, setOpenPaymentReceivedTable] =
    useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [showAddpayment, setShowAddPayment] = useState(false);
  const [showAddExpense, setShowAddExpense] = useState(false);
  const [showcretaedUserName, setShowcretaedUserName] = useState([]);
  const [openFixedExpenseTable, setOpenFixedExpenseTable] = useState(false);
  const project_id = localStorage.getItem("project_id");
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("all");
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [dummyData, setDummyData] = useState("Option 1");

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === "week") {
      setShowDatePicker(true); // Show week calendar
      setShowMonthPicker(false); // Hide month calendar
      setSelectedOption("week"); // Set project span to "week"
    } else if (selectedValue === "month") {
      setShowMonthPicker(true); // Show month calendar
      setShowDatePicker(false); // Hide week calendar
      setSelectedOption("month"); // Set project span to "month"
    } else {
      setShowDatePicker(false); // Hide week calendar
      setShowMonthPicker(false); // Hide month calendar
      setSelectedOption("all"); // Set project span to "all"

      // Call API with 'all' and no date range (or set any default range for "all")
      handleApiCall({
        project_span: "all", // Set project span to "all"
        from_date: null, // or set some default value like "start of year"
        to_date: null, // or set some default value like "end of year"
      });
    }
  };

  const handleDummySelectChange = (event) => {
    setDummyData(event.target.value);
  };

  const handleRangeChange = (ranges) => {
    setDateRange([ranges.selection]);
  };
  const handleApply = () => {
    const startOfWeek = dayjs(dateRange[0].startDate)
      .startOf("week")
      .format("YYYY-MM-DD");
    const endOfWeek = dayjs(dateRange[0].endDate)
      .endOf("week")
      .format("YYYY-MM-DD");

    //console.log()("Selected Week: ", startOfWeek, endOfWeek);

    // Call the API with project_span set to "week"
    handleApiCall({
      project_span: "week", // Set project span to "week"
      from_date: startOfWeek,
      to_date: endOfWeek,
    });

    setShowDatePicker(false); // Close the week picker dialog
  };

  const handleCancel = () => {
    setShowDatePicker(false);
  };

  const handleMonthChange = (newValue) => {
    setSelectedMonth(newValue);
  };
  const handleMonthApply = () => {
    const startOfMonth = selectedMonth.startOf("month").format("YYYY-MM-DD");
    const endOfMonth = selectedMonth.endOf("month").format("YYYY-MM-DD");

    //console.log()("Selected Month: ", startOfMonth, endOfMonth);

    // Call the API with project_span set to "month"
    handleApiCall({
      project_span: "month", // Set project span to "month"
      from_date: startOfMonth,
      to_date: endOfMonth,
    });

    setShowMonthPicker(false); // Close the month picker dialog
  };

  const handleMonthCancel = () => {
    setShowMonthPicker(false);
  };
  const UserNameOptions = useSelector(
    (state) => state.selectOptions?.UserNameOptions
  );

  const handleApiCall = async ({ project_span, from_date, to_date }) => {
    const users = watch("users");
    //console.log()("user_changed : ", users);
    const projectSpan = watch("project_span");
    const requestedData = {
      project_span: project_span || projectSpan, // Week, Month, or All
      from_date: from_date,
      to_date: to_date,
      users,
      // Include any other parameters here as needed
    };

    //console.log()("API Request Data:", requestedData);

    try {
      const response = await getAllData(
        `projects/budget/filter/${project_id}`,
        requestedData
      );
      //console.log()("API Response:", response.data);
      setFilteredData(response); // Update the filtered data
      setLoading(true);
      toast.success(response.message);
    } catch (error) {
      const errorMsg = error.message;
      setFilteredData([]);
      console.error("API Error:", error);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const fetchCreatedByUsers = async () => {
    setLoadingOptions(true); // Start loader
    try {
      const response = await getAllNameList("userDetails");
      //console.log()("getAllUsersDetails names :", response);
      setShowcretaedUserName(response.data);
    } catch (err) {
      console.error("Failed to fetch createdBy users:", err);
      toast.error("Failed to fetch createdBy users");
    } finally {
      setLoadingOptions(false); // Stop loader
    }
  };

  useEffect(() => {
    handleApiCall({ from_date: null, to_date: null });
    fetchCreatedByUsers();
  }, [projectSpan]);

  useEffect(() => {
    //console.log()("Project Span Changed:", projectSpan);
  }, [projectSpan]);
  useEffect(() => {
    const projectSpan = watch("project_span") || "all"; // Ensure default value
    const users = watch("users") || [];

    //console.log()("Project_Span Changed:", projectSpan);
    //console.log()("Users Changed:", users);

    handleApiCall({
      project_span: projectSpan,
      from_date: null, // Default when project_span changes
      to_date: null,
      users,
    });
  }, [watch("project_span"), watch("users")]); // Run when project_span or users change

  const onsubmit = (data) => {
    //console.log()("Form submitted:", data);
  };
  const hadleShowExpense = () => {
    setShowAddExpense(false);
  };

  return (
    <>
      {/* ad payment */}
      <Offcanvas placement="end" show={showAddpayment} style={{ width: "50%" }}>
        <Offcanvas.Body className="p-0">
          <AddPaymentComponent
            onClose={() => setShowAddPayment(false)} // Close the Offcanvas
            onapply={() => {
              //console.log()("Save triggered");
              // setShowAddPayment(false); // Close on apply
            }}
            oncancel={() => {
              //console.log()("Cancel triggered");
              setShowAddPayment(false); // Close on cancel
            }}
          />
        </Offcanvas.Body>
      </Offcanvas>
      {/* add expese */}
      <Offcanvas placement="end" show={showAddExpense} style={{ width: "50%" }}>
        <OffcanvasBody>
          <AddExpenseComponent
            oncancel={() => setShowAddExpense(false)}
            onApply={hadleShowExpense}
            onclose={() => setShowAddExpense(false)}
          />
        </OffcanvasBody>
      </Offcanvas>
      <form action="" onSubmit={handleSubmit(onsubmit)}>
        <div className="d-flex mt-3 gap-3 align-items-center">
          {/* Budget Select Dropdown */}
          <div className="div  flex-grow-1 ">
            <Controller
              name="users"
              control={control}
              rules={{ required: "Users  is required" }}
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  multiple
                  id="users"
                  options={showcretaedUserName}
                  disableCloseOnSelect
                  loading={loadingOptions}
                  getOptionLabel={(option) => option.name}
                  value={
                    value?.map((id) =>
                      showcretaedUserName.find((user) => user.user_id === id)
                    ) || []
                  }
                  onChange={(event, newValue) => {
                    const selectedIds = newValue.map((user) => user.user_id);
                    onChange(selectedIds); // Update form state with user IDs
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      className="d-flex flex-column flex-md-row mb-2"
                    >
                      <Checkbox style={{ marginRight: 8 }} checked={selected} />
                      <Avatar style={{ marginRight: 8 }}>
                        {option.avatar || option.name[0]}
                      </Avatar>
                      <div className="d-flex flex-column">
                        <strong>{option.name}</strong>
                        <small>{option.role}</small>
                      </div>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Enter Users Name" />
                  )}
                  ListboxProps={{
                    style: {
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr", // Two columns
                      gap: "8px",
                      paddingLeft: "0", // Removes default padding
                    },
                  }}
                />
              )}
            />
          </div>

          {/* Project Span Select Dropdown */}
          <div className="container" style={{ width: "300px" }}>
            <div className="d-flex justify-content-center mb-1">
              <FormControl style={{ width: "300px" }} fullWidth>
                <Controller
                  name="project_span"
                  control={control}
                  render={({ field }) => (
                    <Select
                      value={selectedOption}
                      onChange={handleSelectChange}
                      displayEmpty
                      className="w-100"
                    >
                      <MenuItem value="all">All</MenuItem>
                      <MenuItem value="week">Week</MenuItem>
                      <MenuItem value="month">Month</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>

            {/* Week Picker Popup */}
            <Dialog
              open={showDatePicker}
              onClose={handleCancel}
              sx={{ width: "90%" }}
            >
              <DialogTitle>Select Week</DialogTitle>
              <DialogContent>
                <DateRangePicker
                  ranges={dateRange}
                  onChange={handleRangeChange}
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={1}
                  direction="horizontal"
                />
              </DialogContent>
              <DialogActions>
                <button className=" add_btn" onClick={handleApply}>
                  Apply
                </button>
                <button className=" cancel_btn" onClick={handleCancel}>
                  Cancel
                </button>
              </DialogActions>
            </Dialog>

            {/* Month Picker Popup */}
            <Dialog
              open={showMonthPicker}
              onClose={handleMonthCancel}
              sx={{ width: "90%" }}
            >
              <DialogTitle>Select Month</DialogTitle>
              <DialogContent>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StaticDatePicker
                    views={["year", "month"]}
                    value={selectedMonth}
                    onChange={handleMonthChange}
                  />
                </LocalizationProvider>
              </DialogContent>
              <DialogActions>
                <button className=" add_btn" onClick={handleMonthApply}>
                  Apply
                </button>
                <button className=" cancel_btn" onClick={handleMonthCancel}>
                  Cancel
                </button>
              </DialogActions>
            </Dialog>
          </div>

          {/* Buttons */}
          <div className="">
            <button
              className="show-btn text-capitalize border-0"
              onClick={() => setShowAddPayment((open) => !open)}
            >
              add payment
            </button>
          </div>
          <div>
            <button
              className="show-btn mx-1 text-capitalize border-0"
              onClick={() => setShowAddExpense((open) => !open)}
            >
              add expense
            </button>
          </div>
        </div>
      </form>
      {/* budget table */}
      {/*  onClick={handleBudgetToggle} */}
      <button className="budget_dropdown_btn my-4">
        {budgetOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </button>
      <Collapse timeout={700} in={budgetOpen}>
        <BudgetTable filteredData={filteredData} />
      </Collapse>
      {/* fixeed expanse table */}
      <div className="d-flex gap-2 align-items-center ">
        <button
          className="budget_dropdown_btn my-4 "
          onClick={() => setOpenFixedExpenseTable((val) => !val)}
        >
          {openFixedExpenseTable ? <ExpandMoreIcon /> : <ExpandLessIcon />}{" "}
        </button>
        <Typography sx={{ textTransform: "capitalize", fontWeight: "bold" }}>
          fixed expenses
        </Typography>
      </div>
      <Collapse timeout={700} in={openFixedExpenseTable}>
        <FixedExpenses />
      </Collapse>
      {/* payment method table */}
      <div className="d-flex gap-2 align-items-center ">
        <button
          className="budget_dropdown_btn my-4"
          onClick={() => setOpenPaymentReceivedTable((open) => !open)}
        >
          {openPaymentReceivedTable ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </button>
        <Typography sx={{ textTransform: "capitalize", fontWeight: "bold" }}>
          payments received
        </Typography>
      </div>
      <Collapse timeout={700} in={openPaymentReceivedTable}>
        <PaymentsReceived />
      </Collapse>
      {/* summary table */}
      <button
        className="budget_dropdown_btn my-4"
        onClick={() => setOpenSummaryTable((open) => !open)}
      >
        {openSummaryTable ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </button>
      <Collapse timeout={700} in={openSummaryTable}>
        <SummaryTable />
      </Collapse>
    </>
  );
};

export default Budget;
